// extracted by mini-css-extract-plugin
export default {"container":"shopAdminHome_container__gho5j"};